/**
 * Generic localStorage helper utilities
 * Provides common operations for reading, writing, and removing items from localStorage
 */

export function getItem<T>(key: string, defaultValue?: T): T | null {
  try {
    const data = localStorage.getItem(key);
    return data ? JSON.parse(data) : (defaultValue ?? null);
  } catch (error) {
    console.error(`Error reading "${key}" from localStorage:`, error);
    return defaultValue ?? null;
  }
}

export function setItem<T>(key: string, value: T): void {
  try {
    localStorage.setItem(key, JSON.stringify(value));
  } catch (error) {
    console.error(`Error writing "${key}" to localStorage:`, error);
  }
}

export function removeItem(key: string): void {
  try {
    localStorage.removeItem(key);
  } catch (error) {
    console.error(`Error removing "${key}" from localStorage:`, error);
  }
}

export function clear(): void {
  try {
    localStorage.clear();
  } catch (error) {
    console.error("Error clearing localStorage:", error);
  }
}
